import { Helmet } from "react-helmet-async";
import { useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectBrandName } from "modules/settings/redux/selectors";
import { PageSettingContext } from "./context/pageSettingContext";

interface Props {
  title?: string;
}

const PageHelmet = ({ title }: Props): JSX.Element => {
  const {
    state: { pageTitle },
  } = useContext(PageSettingContext);
  const brandName = useSelector(selectBrandName);

  const renderedTitle = useMemo(() => {
    const titleItems = [];

    if (pageTitle) {
      titleItems.push(pageTitle);
    }

    titleItems.push(brandName);

    return title || titleItems.join(" | ");
  }, [title, pageTitle, brandName]);

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{renderedTitle}</title>
    </Helmet>
  );
};

export default PageHelmet;
